import Admin from "./Admin/index.js";
import Brand from "./Brand/index.js";
import BrandMerchant from "./BrandMerchant/index.js";
import Client from "./Client/index.js";
import Merchant from "./Merchant/index.js";
import SmsService from "./SmsService/index.js";
import Category from "./Category/index.js";
import Tag from "./Tag/index.js";
import Block from "./Block/index.js";
import Design from "./Design/index.js";
import Page from "./Page/index.js";
import File from "./File/index.js";
import PaymentGateway from "./PaymentGateway/index.js";
import Promotion from "./Promotion/index.js";
import Company from "./Company/index.js";
import Manager from "./Manager/index.js";
import GasBrand from "./GasBrand/index.js";
import GasBrandMerchant from "./GasBrandMerchant/index.js";
import MerchantPaymentGateway from "./MerchantPaymentGateway/index.js";
import Trunc from "./Trunc/index.js";

export default {
  Admin,
  Block,
  Brand,
  BrandMerchant,
  Category,
  Client,
  Company,
  Design,
  File,
  Manager,
  Merchant,
  Page,
  PaymentGateway,
  Promotion,
  SmsService,
  Tag,
  GasBrand,
  GasBrandMerchant,
  MerchantPaymentGateway,
  Trunc,
};
